<template>
        <v-container class="fill-height">
            <v-row justify="center"
                   align="center">
                <v-card max-width="600">
                    <v-card-text>
                        <h1>Not Authorized</h1>
                    </v-card-text>
                    <v-card-text>
                        <p>
                            The page you are trying to use is not authorized for your role.
                        </p>
                        <p>
                            Please contact administrator or try to logout and login again.
                        </p>
                    </v-card-text>

                    <!--<v-card-text>
                        <p>
                            For your security, your account has been logged out as there was no activity.
                        </p>
                        <p>
                            Please click on following link/button to go back to the login page -
                        </p>
                    </v-card-text>-->
                    <!--<v-card-actions>
                        <v-btn color="black" dark  @click="redirect">Back to login page</v-btn>
                    </v-card-actions>-->
                </v-card>
                </v-row>
        </v-container>
</template>
<script>
    export default {
        name: 'UnAuthorizedPage',
        created()
        {
            this.$store.dispatch('Authentication/logout');
            //this.$store.dispatch('Authentication/deleteCookie', { cookieName: "TokenId",path: "/" });
        },
        methods: {
            redirect() {
                window.location.href = `${process.env.VUE_APP_NEXUSPORTAL_LOGIN_URL}`;
            }
        }
    };
</script>
<style scoped>
    .page-wrap {
        margin-top: 10%;
        width: 100%;
        text-align: center;
    }

        .page-wrap p, a {
            font-size: 1em;
        }

        .page-wrap h2, a {
            text-transform: uppercase;
        }
</style>